// Socket.IO配置
const websocketConfig = {
  // 启用Socket.IO功能，连接到固定服务器
  enabled: true, // 直接启用Socket.IO
  
  // Socket.IO服务器配置
  server: {
    // 固定的Socket.IO服务器URL
    url: 'https://ddos.data.setonink.com', // 固定使用您的服务器
    
    // Socket.IO服务器端口（当url为null时使用）
    port: null, // 不使用，因为已指定完整URL
    
    // Socket.IO路径
    path: '/ws',
    
    // 是否使用SSL（当url为null时生效）
    ssl: true // 使用HTTPS，所以Socket.IO也使用WSS
  },
  
  // 连接配置
  connection: {
    // 最大重连次数
    maxReconnectAttempts: 3,
    
    // 重连间隔（毫秒）
    reconnectInterval: 5000,
    
    // 最大连接失败次数（达到后自动禁用Socket.IO）
    maxConnectionFailures: 10,
    
    // 心跳间隔（毫秒）
    heartbeatInterval: 30000
  },
  
  // 开发模式配置
  development: {
    // 开发环境下是否显示调试日志
    debugLogs: true,
    
    // 开发环境下是否自动重试连接
    autoRetry: true
  }
};

// 根据环境调整配置
if (process.env.NODE_ENV === 'development') {
  // 开发环境下也使用固定的服务器地址（静默）
}

export default websocketConfig; 